/**
 * ResizeManager Class
 */
class ResizeManager {

	/**
	 * Stores an array of registered functions.
	 * @type {Function[]}
	 */
	#functions = [];

	/**
	 * Stores the mobile breakpoint value from CSS variables.
	 * @type {string | null}
	 */
	#mobileBreakpoint = null;

	/**
	 * Constructor
	 *
	 * @return {void}
	 */
	constructor() {

		this.#mobileBreakpoint = getComputedStyle( document.documentElement )
			.getPropertyValue( '--mobile-breakpoint' )
			.trim();
		window.addEventListener( 'resize', this.onResize, { passive: true } );

	}

	/**
	 * Resize event handler
	 *
	 * @return {void}
	 */
	onResize = () => {

		requestAnimationFrame( () => {

			const isMobile = window.matchMedia(
				`(max-width: ${this.#mobileBreakpoint})`
			).matches;
			this.#functions.forEach( ( listener ) => listener( isMobile ) );

		} );

	};

	/**
	 * Add listener
	 *
	 * @param {function} callback
	 * @return {void}
	 */
	addListener = ( callback ) => {

		this.#functions.push( callback );

	};

}

export default new ResizeManager();
